/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_CARTROUTING = '/track';
const RESOURCE_PAGE_ACTION = '/details';
const RESOURCE_PAGE_ROUTING_ACTION = '/contact';
/**
 * findOrderDetailsByMember
 * url - /checkout/{apiversion}/cart/track/details/contact?brand={brandId}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.contactId
 */
const findOrderDetailsByMember = ({
    env, jwtToken, contactId,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    let findOrderDetailsByMemberParam = '';

    if (contactId) {
        findOrderDetailsByMemberParam = `?contactId=${contactId}`;
    }

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_CARTROUTING}${RESOURCE_PAGE_ACTION}${RESOURCE_PAGE_ROUTING_ACTION}${findOrderDetailsByMemberParam}`;

    return restClient.getRequest(envObj, resourcePage, jwtToken)
        .then((response) => response);
};

export default findOrderDetailsByMember;
